$(document).ready(function(){
    $('.shopify-product-form input[name="id"]').change(function(){
        var currentId = $(this).attr('value');
        $('.product-price__line').addClass('hidden');
        $('.product-price__line[data-id="'+currentId+'"]').removeClass('hidden');

    });

    $('.pcu_upsell_box').click(function(){
        $(this).toggleClass('activeup');
    });

    $('.pcu_upsell-select').change(function(){
        var currentId = $(this).val();
        $('.pcu_upsell-img').addClass('hided');
        $('.pcu_upsell-img[data-id="'+currentId+'"]').removeClass('hided');
        
    });


    


    $('.product_comforter-description-tab').click(function(){
        $(this).find('.product_comforter-description_content').slideToggle();
    });


    $('.btn_landing-atc_checkout').click(function(evt) {
        evt.preventDefault();
    
        // Prepare the item list
        var items = [];
        var mainId = $('.shopify-product-form').find('input[name="id"]').attr('value');
        items.push({ id: mainId, quantity: 1 });

      console.log(items);
    
        // Check for checked upsell checkbox
        $('.checkbox-upsell-input:checked').each(function () {
            var giftId = $(this).attr('data-variant-id');
            items.push({ id: giftId, quantity: 1 });
        });
    
        // Additional upsells
        $('.pcu_upsell_box.activeup').each(function () {
            var upsellId = $(this).find('.pcu_upsell-select').val();
            if (upsellId) {
                items.push({ id: upsellId, quantity: 1 });
            }
        });
    
        // First clear the cart, then add items
        $.ajax({
            url: '/cart/clear.js',
            type: 'POST',
            dataType: 'json'
        }).then(function () {
            return $.ajax({
                url: '/cart/add.js',
                type: 'POST',
                dataType: 'json',
                data: {
                    items: items
                }
            });
        }).then(function (res) {
            console.log('Cart cleared and items added:', res);
            window.location.href = "/checkout";
        }).catch(function (err) {
            console.error('Error during cart update:', err);
        });
    });


    $('.qz_summary_btn').click(function(evt){
        evt.preventDefault();

        $('html, body').animate({
            scrollTop: $(".product-single").offset().top
        }, 500);
    });
    
$('.pp-reviews_carousel').slick({
        infinite: true,
        dots: true,
        arrows: false,
        slidesToShow: 1,
    });


    $('.pp-media_main_gallery').slick({
        infinite: true,
        arrows: false,
        slidesToShow: 1,
        asNavFor: '.pp-media_main_gallery_thumbs'
    });

    $('.pp-media_main_gallery_thumbs').slick({
        infinite: true,
        arrows: false,
        slidesToShow: 4,
        centerMode: true,
        centerPadding: '20px',
        asNavFor: '.pp-media_main_gallery',
        focusOnSelect: true
    });

});